"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const PopoverModalForm_1 = require("../components/PopoverModalForm");
const HoverTextInput_1 = require("../components/HoverTextInput");
class AdvancedSettingsRowContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            urlContentEditable: false,
            tempStrValue: '',
        };
        this.handleShowPopoverForm = this.handleShowPopoverForm.bind(this);
        this.handleSaveChange = this.handleSaveChange.bind(this);
        this.handleBlurChange = this.handleBlurChange.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleStartEditText = this.handleStartEditText.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getSettingValue = this.getSettingValue.bind(this);
    }
    handleShowPopoverForm() {
        this.setState({
            urlContentEditable: false,
            tempStrValue: this.getSettingValue(),
        });
    }
    handleSaveChange(str) {
        const { androidOptions, field, iOSOptions, type, updateNotificationDeliverable } = this.props;
        if (type === 'iOS') {
            updateNotificationDeliverable({
                iOSOptions: Object.assign(Object.assign({}, iOSOptions), { [field]: str }),
            });
        }
        if (type === 'Android') {
            updateNotificationDeliverable({
                androidOptions: Object.assign(Object.assign({}, androidOptions), { [field]: str }),
            });
        }
        this.setState({ urlContentEditable: false, tempStrValue: '' });
    }
    handleBlurChange() {
        this.setState({
            urlContentEditable: false,
            tempStrValue: '',
        });
    }
    handleClose() {
        this.setState({
            urlContentEditable: false,
            tempStrValue: '',
        });
    }
    handleAdd() {
        this.handleSaveChange(this.state.tempStrValue);
    }
    handleStartEditText() {
        this.setState({
            urlContentEditable: true,
        });
    }
    getSettingValue() {
        const { androidOptions, field, type, iOSOptions } = this.props;
        if (type === 'iOS') {
            return (iOSOptions[field] || '');
        }
        return androidOptions[field] || '';
    }
    render() {
        const { device, displayText, description, placeholderText, field, type } = this.props;
        const { urlContentEditable, tempStrValue } = this.state;
        const commonChildComponentProps = {
            id: `${field}_advanced_settings`,
            label: displayText,
            media: device,
            text: this.getSettingValue(),
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
        };
        const handleSaveChangeClosePopover = (handleClosePopoverModal, str) => {
            this.handleSaveChange(str);
            handleClosePopoverModal();
        };
        const popoverNavbarProps = (handleClosePopoverModal) => ({
            buttonRight: this.getSettingValue().length === 0 ? 'Add' : 'Update',
            buttonRightCallback: () => {
                this.handleAdd();
                handleClosePopoverModal();
            },
            buttonLeftCallback: () => {
                this.handleClose();
                handleClosePopoverModal();
            },
        });
        const popoverModalProps = (handleClosePopoverModal) => {
            return {
                placement: 'left',
                navBarProperties: Object.assign({ buttonLeft: 'Cancel', id: 'navBarId', style: {
                        containerStyle: {
                            borderRadius: '3px 3px 0px 0px',
                        },
                    } }, popoverNavbarProps(handleClosePopoverModal)),
            };
        };
        const PopoverModalChild = ({ handleSaveChange, key }) => {
            const { device } = this.props;
            const view = (React.createElement("div", { style: {
                    padding: device === 'Tablet' ? 16 : 24,
                    paddingTop: device === 'Tablet' ? 0 : 24,
                }, key: key },
                device === 'Mobile' ? React.createElement(src_1.Text, { text: `${type} ${displayText}`, size: "h1" }) : React.createElement("div", null),
                React.createElement("div", { style: {
                        width: '100%',
                        padding: device === 'Tablet' ? '16px 0 15px' : '24px 0 23px',
                        borderBottom: `1px solid ${src_1.titanium}`,
                    }, onClick: (e) => {
                        e.stopPropagation();
                        this.setState({
                            urlContentEditable: true,
                        });
                    } },
                    React.createElement(src_1.Text, { text: tempStrValue ? tempStrValue : this.getSettingValue(), size: device === 'Tablet' ? 'medium' : 'large', contentEditable: urlContentEditable, handleChange: handleSaveChange, handleBlurChange: this.handleBlurChange, placeholder: true, id: `${field}_advancedSettings`, onBlurChange: true, placeholderText: placeholderText, textStyle: { width: 350 } })),
                React.createElement("div", { style: {
                        paddingTop: device === 'Tablet' ? 16 : 24,
                    } },
                    React.createElement(src_1.Text, { size: device === 'Tablet' ? 'small' : 'medium', text: description }))));
            switch (device) {
                case 'Tablet':
                    return (React.createElement("div", { style: {
                            width: 384,
                            flexDirection: 'column',
                        } }, view));
                case 'Mobile':
                default:
                    return view;
            }
        };
        switch (device) {
            case 'Desktop':
            default:
                const textInputProps = Object.assign(Object.assign({}, commonChildComponentProps), { isEditingText: urlContentEditable, placeholder: placeholderText, startEditingText: this.handleStartEditText, updateText: this.handleSaveChange, deleteText: () => this.handleSaveChange(''), isRequired: false });
                return (React.createElement(HoverTextInput_1.default, { description: description, field: field },
                    React.createElement(src_1.TextInput, Object.assign({}, textInputProps))));
            case 'Tablet':
            case 'Mobile':
                return (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: Object.assign(Object.assign({}, commonChildComponentProps), { isEditingText: false, textMode: true }), presentationType: device === 'Mobile' ? 'modal' : 'popover', field: field, popoverModalProps: popoverModalProps, popoverNavbarProps: popoverNavbarProps, handleShowPopoverForm: this.handleShowPopoverForm, handleSaveChange: handleSaveChangeClosePopover },
                    React.createElement(PopoverModalChild, null)));
        }
    }
}
const mapStateToProps = (state) => {
    const { iOSOptions, androidOptions } = reducers_1.getEditableCampaignDeliverable(state);
    return {
        iOSOptions: Object.assign({ categoryIdentifier: null, contentAvailable: false, mutableContent: null, sound: null, threadIdentifier: null }, iOSOptions),
        androidOptions: Object.assign({ channelID: null, tag: null }, androidOptions),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateNotificationDeliverable: (d) => {
            dispatch(actions_1.updateNotificationDeliverable(d));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AdvancedSettingsRowContainer);
